// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "resource/js/components/dashboard" + "." + "1a94add6" + ".css";
};